// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 코드 관리 화면 - 공통 스타일은 PageLayout.css 참조 */

/* 코드타입 배지 */
.type-badge {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.type-SECTOR    { background-color: #e3f2fd; color: #1565c0; }
.type-TERM_TYPE { background-color: #e8f5e9; color: #2e7d32; }

/* 조회조건 select */
.filter-select {
  padding: 5px 9px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
}

/* 행 배경색 - admin 코드: 연회색, 내 코드: 흰색, 수정/신규: 연노란색 */
.cm-row-admin td { background-color: #f5f5f5; }
.cm-row-own   td { background-color: #ffffff; }

.cm-row-changed td,
.cm-row-new     td {
  background-color: #fffde7 !important;
}

/* 소유자 컬럼 */
.cell-userid {
  font-size: 11px;
  color: #666;
  font-family: monospace;
}

/* 인라인 편집 input */
.cell-input {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 12px;
  background: #fff;
  font-family: inherit;
}

.cell-input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);
}

.cm-row-admin .cell-input,
.cm-row-own   .cell-input {
  background: #fff;
}

.cm-row-changed .cell-input,
.cm-row-new     .cell-input {
  background: #fff;
}

.cell-number {
  width: 56px;
  text-align: right;
}

.cell-readonly {
  font-size: 12px;
  color: #333;
}

/* disabled 버튼 tooltip */
.tooltip-wrapper {
  display: inline-block;
  cursor: not-allowed;
}

.tooltip-wrapper button:disabled {
  pointer-events: none;
  opacity: 0.4;
}

/* 툴바 구분선 (저장 버튼 앞 간격) */
.toolbar-sep {
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #dde2ef;
  margin: 0 4px;
  flex-shrink: 0;
}

/* 비고 컬럼 - 고정폭 없이 남은 공간 채움 */
.col-bigo {
  white-space: normal;
  min-width: 60px;
}

/* btn-outline 스타일 (admin 코드 가져오기 버튼)
   .btn의 border:none을 !important로 오버라이드 */
.btn-outline {
  background: white;
  border: 1px solid #4a90e2 !important;
  color: #4a90e2;
}

.btn-outline:hover:not(:disabled) {
  background: #e8f0fb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/reference/CodeMasterPage.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C,YAAY;AACZ;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB,yBAAyB,EAAE,cAAc,EAAE;AAC7D,kBAAkB,yBAAyB,EAAE,cAAc,EAAE;;AAE7D,gBAAgB;AAChB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iDAAiD;AACjD,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;;AAE9C;;EAEE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;yCACyC;AACzC;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* 공통 코드 관리 화면 - 공통 스타일은 PageLayout.css 참조 */\n\n/* 코드타입 배지 */\n.type-badge {\n  display: inline-block;\n  padding: 1px 7px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.type-SECTOR    { background-color: #e3f2fd; color: #1565c0; }\n.type-TERM_TYPE { background-color: #e8f5e9; color: #2e7d32; }\n\n/* 조회조건 select */\n.filter-select {\n  padding: 5px 9px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n}\n\n/* 행 배경색 - admin 코드: 연회색, 내 코드: 흰색, 수정/신규: 연노란색 */\n.cm-row-admin td { background-color: #f5f5f5; }\n.cm-row-own   td { background-color: #ffffff; }\n\n.cm-row-changed td,\n.cm-row-new     td {\n  background-color: #fffde7 !important;\n}\n\n/* 소유자 컬럼 */\n.cell-userid {\n  font-size: 11px;\n  color: #666;\n  font-family: monospace;\n}\n\n/* 인라인 편집 input */\n.cell-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 3px 6px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 12px;\n  background: #fff;\n  font-family: inherit;\n}\n\n.cell-input:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.15);\n}\n\n.cm-row-admin .cell-input,\n.cm-row-own   .cell-input {\n  background: #fff;\n}\n\n.cm-row-changed .cell-input,\n.cm-row-new     .cell-input {\n  background: #fff;\n}\n\n.cell-number {\n  width: 56px;\n  text-align: right;\n}\n\n.cell-readonly {\n  font-size: 12px;\n  color: #333;\n}\n\n/* disabled 버튼 tooltip */\n.tooltip-wrapper {\n  display: inline-block;\n  cursor: not-allowed;\n}\n\n.tooltip-wrapper button:disabled {\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n/* 툴바 구분선 (저장 버튼 앞 간격) */\n.toolbar-sep {\n  display: inline-block;\n  width: 1px;\n  height: 18px;\n  background: #dde2ef;\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n\n/* 비고 컬럼 - 고정폭 없이 남은 공간 채움 */\n.col-bigo {\n  white-space: normal;\n  min-width: 60px;\n}\n\n/* btn-outline 스타일 (admin 코드 가져오기 버튼)\n   .btn의 border:none을 !important로 오버라이드 */\n.btn-outline {\n  background: white;\n  border: 1px solid #4a90e2 !important;\n  color: #4a90e2;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #e8f0fb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
